import React, { useEffect, useState } from 'react';
import Layout from '../../layout/Main/Layout';
import { Typography, TextField, Button, Paper, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { get, put } from '../../config/axios';
import toast from 'react-hot-toast';

const Home = () => {
    const [content, setContent] = useState("");
    const [suggestions, setSuggestions] = useState([
        { percentage: "", text: "" },
        { percentage: "", text: "" },
        { percentage: "", text: "" },
    ]);

    console.log("home suggestion", suggestions)

    // GET request function
    const getHomeData = async () => {
        try {
            const data = await get(`/api/dashboard/website/home`);
            const heroSection = data.filter((item) => item.section == "home-hero-section")[0]
            setContent(heroSection)
            const homeSuggestionContent = data.filter((item) => item.section == "suggestion-and-content")[0]
            setSuggestions(homeSuggestionContent)
            console.log("Fetched data:", data);
        } catch (error) {
            console.error("Error fetching heading:", error);
        }
    };

    useEffect(() => {
        getHomeData()
    }, [])

    const handleUpdate = async (id) => {
        try {
            const response = await put(`/api/dashboard/website/home/${content._id}`, { content: content.content });
            toast.success("Home page content updated successfully!");
            console.log("Updated Data:", response);
        } catch (error) {
            console.error("Error updating content:", error);
            toast.error("Failed to update content!");
        }
    };

    const handleSuggestionsUpdate = async () => {
        try {
            const response = await put(`/api/dashboard/website/home/${suggestions._id}`, { content: suggestions.content });
            toast.success("Home page content updated successfully!");
            console.log("Updated Data:", response);
        } catch (error) {
            console.error("Error updating content:", error);
            toast.error("Failed to update content!");
        }
    };

    const handleSuggestionChange = (index, field, value) => {
        const updatedSuggestions = suggestions.content;
        updatedSuggestions[index][field] = value;
        setSuggestions({ ...suggestions, content: updatedSuggestions });
    };

    return (
        <Layout>
            <div style={{ padding: "1rem" }}>
                {/* Hero Section */}
                <Typography variant="h5" paddingBottom={1}>Manage Website Home Page Content</Typography>
                <Paper sx={{ padding: 2, width: '100%', maxWidth: 600, marginBottom: 3 }}>
                    <TextField
                        fullWidth
                        multiline
                        variant="outlined"
                        value={content.content}
                        onChange={(e) => {
                            if (e.target.value.length <= 50) {
                                setContent({ ...content, content: e.target.value });
                            }
                        }}
                        sx={{ marginBottom: 2 }}
                        inputProps={{
                            maxLength: 50
                        }}
                        helperText={`${content.content?.length || 0}/50 characters`}
                        FormHelperTextProps={{
                            sx: {
                                textAlign: 'right',
                                marginRight: 0
                            }
                        }}
                    />
                    <Button variant="contained" color="primary" onClick={handleUpdate}>
                        Update
                    </Button>
                </Paper>

                {/* Suggestions & Content Section */}
                <Typography variant="h6" marginTop={3}>Home Testimonials left section</Typography>
                <Paper sx={{ padding: 2, width: '100%', maxWidth: "95%", marginBottom: 3, marginTop: 1 }}>
                    {suggestions?.content?.map((item, index) => (
                        <Grid container spacing={2} key={index} sx={{ marginBottom: 2 }}>
                            <Grid item xs={2}>
                                <TextField
                                    fullWidth
                                    label="Percentage"
                                    variant="outlined"
                                    placeholder="%"
                                    value={item.percentage}
                                    onChange={(e) => handleSuggestionChange(index, "percentage", e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={10}>
                                <TextField
                                    fullWidth
                                    label="Content"
                                    variant="outlined"
                                    value={item.text}
                                    onChange={(e) => handleSuggestionChange(index, "text", e.target.value)}
                                />
                            </Grid>
                        </Grid>
                    ))}
                    <Button variant="contained" color="primary" onClick={handleSuggestionsUpdate}>
                        Update
                    </Button>
                </Paper>
            </div>
        </Layout>
    );
};

export default Home;
